import { Attributes, createElement } from 'react'

import { FieldSettings } from '../../../ana-toolbox'
import { AddressField, AddressFieldProps } from '../../components/address-field/address-field'
import { CheckboxField } from '../../components/checkbox-field/checkbox-field'
import { DatePickerField } from '../../components/date-picker-field/date-picker-field'
import { PhoneField } from '../../components/phone-field/phone-field'
import { RadioGroupProps, RadioGroup } from '../../components/radio-group/radio-group'
import { SelectField, SelectFieldProps } from '../../components/select-field/select-field'
import { TextField } from '../../components/text-field/text-field'
import { TextFieldProps } from '../../components/text-field/text-field.types'
import { ToggleField, ToggleFieldProps } from '../../components/toggle-field/toggle-field'

const componentsByType = {
  address: AddressField,
  date: DatePickerField,
  phone: PhoneField,
  radioGroup: RadioGroup,
  select: SelectField,
  text: TextField,
  toggle: ToggleField,
  checkbox: CheckboxField,
}

const getProps = (fieldSettings: FieldSettings) => {
  if (fieldSettings.__type === 'radioGroup') {
    return {
      name: fieldSettings.name,
      options: fieldSettings.options,
      label: fieldSettings.label,
      required: fieldSettings.isRequired,
      helperText: fieldSettings.helperText,
      helperData: fieldSettings.helperData,
    } as RadioGroupProps
  }

  if (fieldSettings.__type === 'toggle') {
    return {
      name: fieldSettings.name,
      label: fieldSettings.label,
      helperText: fieldSettings.helperText,
      disabled: fieldSettings.inputProps?.disabled,
    } as ToggleFieldProps
  }

  if (fieldSettings.__type === 'text') {
    return {
      name: fieldSettings.name,
      label: fieldSettings.label,
      required: fieldSettings.isRequired,
      helperText: fieldSettings.helperText,
      type: fieldSettings.inputProps?.type,
      placeholder: fieldSettings.inputProps?.placeholder,
      inputComponent: fieldSettings.inputProps?.inputComponent,
      InputLabelProps: fieldSettings.inputProps?.InputLabelProps,
      onFocus: fieldSettings.inputProps?.onFocus,
      onBlur: fieldSettings.inputProps?.onBlur,
    } as TextFieldProps
  }

  if (fieldSettings.__type === 'phone') {
    return {
      name: fieldSettings.name,
      label: fieldSettings.label,
      required: fieldSettings.isRequired,
      helperText: fieldSettings.helperText,
      type: fieldSettings.inputProps?.type,
      flagSource: fieldSettings.flagSource,
      placeholder: fieldSettings.inputProps?.placeholder,
    }
  }

  if (fieldSettings.__type === 'address') {
    return {
      name: fieldSettings.name,
      label: fieldSettings.label,
      required: fieldSettings.isRequired,
      helperText: fieldSettings.helperText,
      type: fieldSettings.inputProps?.type,
      placeholder: fieldSettings.inputProps?.placeholder,
      onReceiveAddress: () => {},
    } as AddressFieldProps
  }

  if (fieldSettings.__type === 'select') {
    return {
      name: fieldSettings.name,
      label: fieldSettings.label,
      required: fieldSettings.isRequired,
      helperText: fieldSettings.helperText,
      type: fieldSettings.inputProps?.type,
      options: fieldSettings.options,
    } as SelectFieldProps
  }

  if (fieldSettings.__type === 'date') {
    return {
      name: fieldSettings.name,
      label: fieldSettings.label,
      required: fieldSettings.isRequired,
      helperText: fieldSettings.helperText,
    }
  }

  if (fieldSettings.__type === 'checkbox') {
    return {
      name: fieldSettings.name,
      label: fieldSettings.label,
      helperText: fieldSettings.helperText,
    }
  }
}

export const createField = (fieldSettings: FieldSettings) => {
  if (!fieldSettings.__type) return null

  const Component = componentsByType[fieldSettings.__type as keyof typeof componentsByType]

  if (!Component) {
    console.error(`Component of type ${fieldSettings.__type} could not be found.`)

    return null
  }

  return createElement(Component as React.FC, getProps(fieldSettings) as Attributes)
}
